module.exports = __webpack_public_path__ + "img/logo_completo.dc727aa6.svg";